import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { createRxValueWithCache } from "@app/_helpers/rx-value";
import { FadeInOut, SlideUpDown, SlideUpDownBump } from "@app/animations/fade";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { MediaObserver } from "ngx-flexible-layout";
import { map } from "rxjs";
import { TimerService } from "./timer-calendar-view.service";

export const TIMEFORMAT = {
	parse: { dateInput: "H:mm:ss" },
	display: {
		dateInput: "H:mm:ss",
		monthYearLabel: "MMM YYYY",
		dateA11yLabel: "LL",
		monthYearA11yLabel: "MMMM YYYY",
	},
};

@UntilDestroy()
@Component({
	selector: "app-timer-home-page",
	templateUrl: "./timer-home-page.component.html",
	styleUrls: ["./timer-home-page.component.scss"],
	animations: [FadeInOut, SlideUpDown, SlideUpDownBump],
	providers: [{ provide: MAT_DATE_FORMATS, useValue: TIMEFORMAT }],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimerHomePageComponent implements OnInit {
	readonly isLoading$ = this.service.isLoading$;
	readonly projecthoursEnabled = this.service.projecthoursEnabled;
	readonly workinghoursEnabled = this.service.workinghoursEnabled;
	readonly selectedViewMode = createRxValueWithCache("selectedViewMode", "calendar");
	readonly isMobile$xs = this.media
		.asObservable()
		.pipe(map((x) => x.findIndex((y) => ["xs"].includes(y.mqAlias)) !== -1));
	displayModeLoading: string | null = null;
	viewChange(view: "list" | "calendar") {
		this.selectedViewMode.update((v) => view);
	}
	readonly schedule$ = this.service.schedule$;

	constructor(
		private media: MediaObserver,
		private service: TimerService
	) {}

	ngOnInit() {
		this.service.rangeFetch$.pipe(untilDestroyed(this)).subscribe();
	}
}
